import React from 'react';
import { CDN_URLS } from '../config/cdn';
import SpriteAnimatedLogo from '../ui/SpriteAnimatedLogo.js';
import { DEFAULT_ANIM_FRAME_RATE } from '../config/const.js';
import { SPRITES } from '../ui/SpriteAnimatedLogo.js';

const Benchmark = () => {
  return (
    <section className="benchmark">
      <div className="benchmark-container">
        <div className="benchmark-chart">
          <div style={{ position: 'relative' }}>
            <img src={CDN_URLS.benchmark} alt="Benchmark chart" className="chart-graphic" />
            <div className="benchmark-anim1">
              <SpriteAnimatedLogo
                width={80}
                height={80}
                frameRate={DEFAULT_ANIM_FRAME_RATE}
                autoPlay={true}
                filename={SPRITES.ANIM_CLIMB_WALL} />
            </div>
          </div>
        </div>
        <div className="benchmark-content">
          <div className="benchmark-text">
            <h3>Benchmarking <img src="/local/memu-logo.svg" alt="MemU" style={{ height: '1.3em', verticalAlign: 'middle', marginLeft: '0.0em', marginTop: '-0.3em' }} /></h3>
            <p>MemU achieves 92.09% average accuracy in Locomo dateset across all reasoning tasks, significantly outperforming competitors.</p>
          </div>
          <button className="btn btn-primary btn-md">View research (Coming soon)</button>
        </div>
      </div>
    </section>
  );
};

export default Benchmark;